// extracted by mini-css-extract-plugin
module.exports = {"StyledWrapper":"CountdownDate_StyledWrapper__3ZVIp","StyledCaption":"CountdownDate_StyledCaption__3zXEa","StyledCounter":"CountdownDate_StyledCounter__1rvTY"};